import { Component, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import IpErrorResponse from './invopay/interfaces/ip-error-response';
import { DataCompany } from './invopay/interfaces/lip-data-company';
import { IpCompanyService } from './invopay/services/ip-company.service';
import { IpInfoSharedCompanyService } from './invopay/services/ip-info-shared-company.service';
import { IpSharingUrlService } from './invopay/services/ip-sharing-url.service';
import { IpSnackbarService } from './invopay/services/ip-snackbar.service';
import { ThemeService } from './shared/services/theme.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  subdomain = 'https://techforb.invopay.tech.com/asklsd';
  dominio: string = '';
  translationsLoaded = false;

  constructor(
    private translateService: TranslateService,
    private themeService: ThemeService,
    private companyService: IpCompanyService,
    private infoSharedCompany: IpInfoSharedCompanyService,
    private url: IpSharingUrlService,
    private ipSnackbarService: IpSnackbarService,
  ) {
    // Use default language
    translateService.use('es');
  }

  ngOnInit() {
    if (!environment.production) {
      console.log('Entorno: ' + environment.strEnvironment);
    }
    this.dominio = window.location.href;
    this.url.setUrl(this.subdomain);
    // TODO
    // this.getInfoCurrentCompany();
    this.applyTheme();
    this.translateService.onLangChange.subscribe({
      next: (event: LangChangeEvent) => {
        if (event.translations) {
          this.translationsLoaded = true;
        }
        else {
          console.warn("Couldn't find translations.");
          this.ipSnackbarService.showUnexpectedErrorMessage();
        }
      },
      error: (e: IpErrorResponse) => {
        console.warn("Couldn't get translations.");
        this.ipSnackbarService.showErrorMessage(e);
      }
    })
  }

  private applyTheme() {
    this.themeService.getTheme().subscribe((theme: any) => {
      for (const key of Object.keys(theme)) {
        const cssVarName = `--${key}`;
        document.documentElement.style.setProperty(cssVarName, theme[key]);
      }
    });
  }

  getInfoCurrentCompany() {
    this.companyService.getCompanyData(this.url.getUrl()).subscribe({
      next: (data: DataCompany) => {
        this.infoSharedCompany.setSharingInfo(data);
        let language = data.language;
        if (language !== 'es' && language !== 'pt') {
          // Set default language
          language = 'es';
        }
        localStorage.setItem('language', language);
        this.translateService.use(language);
        console.log(data);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }
}
